export var Horizontal = {
  Center: 'center',
  Left: 'left',
  Right: 'right'
};